export const initialValuesTermOfPayment = {
  note_short: "",
  note_description: "",
};
